"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getErrorMessageWithIntl = void 0;
var _thirdPartyLogin = require("../constants/thirdPartyLogin");
var _messages = _interopRequireDefault(require("../messages"));
const getErrorMessageWithIntl = _ref => {
  let {
    thirdPartyLoginProps = {},
    intl
  } = _ref;
  if (!intl) return null;
  const {
    type,
    errors
  } = thirdPartyLoginProps;
  if (type === _thirdPartyLogin.EHR_MYCHART) {
    const [error] = errors;
    switch (error) {
      // Various errors may be handled differently in the future,
      // but for now, treat them as a general error.
      case _thirdPartyLogin.ERROR.ERROR_EHR_INVALID_PID:
      case _thirdPartyLogin.ERROR.ERROR_EHR_INVALID_ACCESS_TOKEN:
      case _thirdPartyLogin.ERROR.ERROR_EHR_INVALID_SOURCE_SYSTEM:
      case _thirdPartyLogin.ERROR.ERROR_EHR_NOT_AUTHORIZED_BY_USER:
      case _thirdPartyLogin.ERROR.ERROR_EHR_LOGIN:
      default:
        {
          return {
            description: intl.formatMessage(_messages.default.mychartLoginErrorDescription),
            action: intl.formatMessage(_messages.default.mychartLoginErrorAction)
          };
        }
    }
  }
  return null;
};
exports.getErrorMessageWithIntl = getErrorMessageWithIntl;